// Fashion till theme: one fixed CW Design System shell for every tenant.
// Tenants set only their store name and logo, so older per-store theme
// settings (Threadline, Nordvik, Lune) are ignored.

export const FASHION_THEMES = ["cw"];
export const DEFAULT_FASHION_THEME = "cw";

export const normaliseTheme = (value) => {
  if (typeof value !== "string") return null;
  const name = value.trim().toLowerCase().replace(/^th-/, "");
  return FASHION_THEMES.includes(name) ? name : null;
};

export function resolveFashionTheme() {
  return DEFAULT_FASHION_THEME;
}

export const themeClass = () => `th-${DEFAULT_FASHION_THEME}`;
